module.exports = __webpack_public_path__ + "img/ico-posts.ac02e178.svg";